/// <summary>
/// <br/>
/// Author: MWI<br />
/// Date: 02.12.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.2 - 19.01.2018                                               *<br />
/// **********************************************************************<br />
/// *- editable for ws-calls better integrated                          *<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 26.01.2016                                               *<br />
/// **********************************************************************<br />
/// * - documentation, fixed bug in Btn Back                             *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 11.12.2015                                               *<br />
/// **********************************************************************<br />
/// * - migrated from Gallery to split     Upload and maybe Grid in part *<br />
/// **********************************************************************<br />
///</summary>
function galleryUpload() {

    this.source = "galleryUpload";

}
galleryUpload.prototype = new window.vcTemplate();

galleryUpload.prototype.init = function () {
    /// <summary>
    /// init function prepares the Formular and presets <br/>
    /// values if any are present respectively sets them to standard <br/>
    /// furthermore sets the clickhandlers and and disables all buttons except the back button
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        if (me.mobile === true) {
            me.visual.toggleClass("mb");
        }

      
        me.showInfo("", "", false);
        if (me.data.mediaId !== -1) {
            me.visual.find("#txtFileName").val(me.data.mediaName).change();
            me.visual.find("#txtDesc").val(me.data.mediaDesc).change();
            me.visual.find("#txtMediaFormat").val(me.data.mediaFormat).change();
            me.visual.find("#txtMediaPath").val(me.data.mediaPath).change();
            me.visual.find("#txtMediaType").val(me.data.mediaType).change();
            me.visual.find("#previewImage").attr("src", me.data.mediaPath);
            me.visual.find("#chbGlobal").prop("checked", me.data.isGlobal).change();

            me.visual.find("#ddlMediaCat").val(me.data.mediaCategory);

            me.setPreview(me.resources.noFileSelected, me.data.mediaFormat, me.data.mediaType === "IMAGE", me.data.mediaPath);
            me.visual.find("#btnDownload").attr("download", me.data.mediaName + "." + me.data.mediaFormat);

            me.visual.find("#btnDownload").attr("href", me.data.mediaPath);

        } else {
            me.visual.find("#btnDownload").hide();
            me.setPreview(me.resources.noFileSelected, ".png", true, "../../images/drop-here.png");
            me.visual.find("#chbGlobal").prop("checked", false).change();
        }
        me.visual.find("#btnUploadField").button().off("click").on("click", function () { me.visual.find("#txtUploadField").trigger("click"); });

        me.visual.find("#btnBackUpload").button().off("click").on("click", function () { me.btnBack(me); });
        me.visual.find("#btnDownload").button({ disabled: false }).off("click").on("click", function () { });

        me.visual.find("#btnSave").button({ disabled: true }).off("click").on("click", function () { me.save(me); });
        me.visual.find("#btnDelete").button({ disabled: true }).off("click").on("click", function () { me.delete(me); });
        me.visual.find("#btnRotate").button({ disabled: true }).off("click").on("click", function () { me.rotateImage(me); });

        me.visual.find("#chosenFile").html(me.resources.noFileSelected);
        me.visual.find("#txtFileName, #txtDesc, #chbGlobal").off("input propertychange change").on("input propertychange change", function () { me.validateGallery(); });
        me.setButtonStates();
        me.createUploader();
        me.visual.find("#divProgressbar").progressbar().progressbar("value", 0);
        me.visual.find("#divProgressbar .ui-progressbar-value").addClass("color-font-primary", true);
        me.visual.find("#divProgressbar").off("progressbarcomplete").on("progressbarcomplete", function () {
            me.visual.find("#divProgressbar .ui-progressbar-value").html(me.resources.uploadSuccess);
        });
        me.visual.find("#divProgressbar").off("progressbarchange").on("progressbarchange", function () {
            me.visual.find("#divProgressbar .ui-progressbar-value")
                .html(me.visual.find("#divProgressbar").attr("aria-valuenow") + "%");
        });

        return true;
    } catch (ex) {
        me.error = true;
        me.writeError('GalleryUpload.init', ex);
        return false;
    }
};

galleryUpload.prototype.createUploader = function () {
    //<summary>
    //    generates the JS Upload <br />
    //    in here the fileuplod configuration is prepared <br/>
    //    with e.g. functions for error handling in the fileupload 
    //</summary>
    // <returns>false on error, true otherwise</returns>
    var me = this;
    try {
       
        me.visual.find('#txtUploadField').fileupload({
            dropZone: me.visual.find('#dropZone'),
            dataType: 'json',
            url: '../bluaul/UploadHandler.ashx',
            recalculateProgress: false,
            add: function (e, data) {

                me.visual.find("#frmSettings").hide();
                me.visual.find("#div-loading").show();
                if (me.validateFile(data.files[0]) === true) {
                   
                    me.setPreview(data.files[0].name, data.files[0].name.substring(data.files[0].name.lastIndexOf('.')), data.files[0].type.indexOf('image') > -1, data.files[0]);
               
                    if (me.visual.find('#txtFileName').val().trim().length === 0) me.visual.find('#txtFileName').val(data.files[0].name.substring(0, data.files[0].name.lastIndexOf('.'))).change();
                    me.file = data.files[0];
                    data.submit();
                    me.setButtonStates();
                    me.visual.find("#btnSave").button("disable");

                } else {
                    me.visual.find('#previewImage').attr('src', '../../images/drop-here.png');
                    me.visual.find('#previewIcon').hide();
                    me.visual.find('#previewImage').show();
                }
            },
            progress: function (e, data) {
                //me.visual.find("#divUploading").show();
              
                //me.visual.find('#divUploadProgress').html(parseInt(data.loaded / data.total * 100, 10) + '%');
                //me.visual.find('#divProgressbar').progressbar("value", parseInt(data.loaded / data.total * 100, 10));

                //console.info("upload progess");

            },
            error: function (e, data) {
                me.visual.find("#frmSettings").hide();
                me.visual.find("#div-loading").hide();
                me.showInfo(me.resources.uploadError, data.textStatus, true);
                //alert("file upload error 1");
            },
            done: function (e, data) {
                //console.info("upload done ");
                if (data.result.Error) { //the server had some error while uploading 
                    me.showInfo(me.resources.errOnServer, data.result.Error, true);
                    me.visual.find("#frmSettings").hide();
                    me.visual.find("#div-loading").hide();
                    //alert("file upload error");
                } else {
                    me.visual.find("#frmSettings").show();
                    me.visual.find("#div-loading").hide();
                    //'save the values in the database only if the upload was successfull as well as only show the rotate image then
                    if (data.result.files[0].MediaFormat === 'IMAGE') me.visual.find('#imgRotateIcon').show();
                    me.visual.find('#txtMediaFormat').val(data.result.files[0].FileEnding);
                    me.visual.find('#txtMediaPath').val(data.result.files[0].MediaPath);
                    me.visual.find('#txtMediaType').val(data.result.files[0].MediaFormat);
                    me.visual.find('#previewImage').attr('src', getMediaDataUrl(data.result.files[0].MediaPath));
                    me.data.mediaPath = data.result.files[0].MediaPath;
                    me.data.mediaType = data.result.files[0].MediaFormat;
                    me.data.mediaFormat = data.result.files[0].FileEnding;
                    me.data.mediaSize = data.result.files[0].FileSize;
                    me.data.mediaDim = data.result.files[0].Dimension;
                    me.setButtonStates();
                    me.visual.find("#btnSave").button("enable");

                    //alert("file uploaded");
                }
            }
        });
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.createUploader", ex);
        return false;
    }
    return true;
};
galleryUpload.prototype.doEvent = function () { };
galleryUpload.prototype.btnBack = function (me) {
    ///<summary>
    ///ClickHandler function for the Back Button <br/>
    ///removes the selected class from the new Button button and loads the Gallery
    ///</summary>
    var btnBackElement;
    try {
        $("#selNewWidget").removeClass("ui-selected");
        btnBackElement = me.btnBackToItem;
        if (me.mediaCategory === "PRIVATE") {
            btnBackElement += "_USER";
        }
        window.VisualCoreService.getVisualContentByName(btnBackElement, "gallery", window.getCurrentTimestamp(), 500, 900,
            JSON.stringify({ mediaCategory: me.mediaCategory, editable: me.editable, bsaid: me.bsaid }),
            JSON.stringify({ mediaCategory: me.mediaCategory, editable: me.editable, bsaid: me.bsaid, btnBackToItem: me.btnBackToItem, btnBackToItemDiv: me.btnBackToItemDiv, 'mediaId': me.data.mediaId, rrid: me.data.rrid }),
            2,
            function (result) {
                if (me.btnBackToItemDiv.startsWith("#") === false) {
                    me.btnBackToItemDiv = "#" + me.btnBackToItemDiv;
                }

                $(me.btnBackToItemDiv).html(result);
            });

        //window._VCMQ.produce(me.visual, me.vcgid, 'GALMEN_LOAD', { "btnBackTo": me.btnBackToItem });
    } catch (ex) {
        me.error = true;
        me.showInfo(me.resources.err_code, true);
        me.writeError("GalleryUpload.btnBack", ex);
    }
};

galleryUpload.prototype.save = function (me) {
    ///<summary>   
    /// calls the Webservice and saves the file <br/>
    /// with the current settings in the database
    ///</summary>
    try {

        if (me.file || me.data.mediaId !== -1) {

            me.visual.find("#btnDelete").button("disable");
            me.visual.find("#btnRotate").button("disable");
            me.data.updateType = 1; //1 = Save Media
            me.data.mediaName = window.trimAll(me.visual.find("#txtFileName").val());
            me.data.mediaDesc = window.trimAll(me.visual.find('#txtDesc').val());

            me.data.isGlobal = me.visual.find('#chbGlobal').prop('checked');
            me.data.mediaCategory = me.visual.find('#ddlMediaCat option:selected').val();
            if (me.mediaCategory === "PRIVATE") {
                me.data.mediaCategory = me.visual.find('#ddlMediaCat option:selected').val();
            } else {
                me.data.mediaCategory = me.mediaCategory;
            }
            if (me.data.isGlobal === true) {
                me.openAskDialog(me.resources.mediaPublicWarning, { "at": "center center", of: window }, function () {
                    me.saveWsCall();
                });
            } else {
                me.saveWsCall();
            }
        }
    } catch (ex) {
        me.writeError("GalleryUpload.saveMedia", ex);
    }
};

galleryUpload.prototype.saveWsCall = function () {
    var me = this;
    try {
        //alert("file save");
        //console.info(me.data);
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, JSON.stringify({ mediaCategory: me.data.mediaCategory }), '', 2, 2, JSON.stringify(me.data), function (result) {
            var resObj = JSON.parse(result);
            me.showInfo(resObj.text, resObj.hasError);
            me.data.mediaId = resObj.mediaId;
            me.setButtonStates();
            window._VCMQ.produce(me.visual, me.vcgid, 'GALLERY_CHANGED', { "id": me.data.signalid, "mediaId": me.data.mediaId });

        });
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.saveWsCall", ex);
    }
};

galleryUpload.prototype.delete = function (me) {
    ///<summary>   
    /// calls the Webservice and saves the file <br/>
    /// with the current settings in the database
    ///</summary>
    try {
        me.visual.find('#btnSave').button("disable");
        me.visual.find('#btnRotate').button("disable");
        me.visual.find('#btnDelete').button("disable");

        me.data.updateType = 4; //1 = Save Media
        me.data.mediaName = window.trimAll(me.visual.find('#txtFileName').val());
        me.data.mediaDesc = window.trimAll(me.visual.find('#txtDesc').val());
        me.data.isGlobal = me.visual.find('#chbGlobal').prop('checked');
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, JSON.stringify({ mediaCategory: me.visual.find("#txtMediaType").val() }), '', 2, 2, JSON.stringify(me.data),
            function (result) {
                var resObj = JSON.parse(result);
                if (resObj.hasError) {
                    me.showInfo(me.resources.errNotDeleted, resObj.text, resObj.hasError);
                } else {
                    me.data.mediaId = -1;
                    me.visual.find("#txtFileName").val("");
                    me.visual.find("#txtDesc").val("");
                    me.visual.find("#chbGlobal").prop("checked", false).change();
                    me.setPreview(me.resources.noFileSelected, ".png", true, "../../images/drop-here.png");
                    me.file = null;
                    me.visual.find("#upload").hide();
                    me.showInfo(me.resources.deleteSucessfull, "", resObj.hasError);
                    window._VCMQ.produce(me.visual, me.vcgid, 'GALLERY_CHANGED', { "id": "-1", "mediaId": "-1" });

                    setTimeout(function () {
                        window._VCMQ.produce(me.visual, me.vcgid, 'GALMEN_LOAD', null);
                    }, 1000);
                }
                //me.setButtonStates();
            });
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.deleteMedia", ex);
    }
};

galleryUpload.prototype.setButtonStates = function () {
    ///<summary>
    ///enables the three top buttons according to the state the upload is in
    ///</summary>
    var me = this;
    try {
        me.visual.find("#btnSave, #btnRotate, #btnDelete")
            .button({ disabled: me.data.mediaId === -1 || me.invalidInput });
        if (me.data.mediaType !== "IMAGE") {
            me.visual.find("#btnRotate").button("disable");
        }
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.setButtonStates", ex);
    }
};

galleryUpload.prototype.rotateImage = function (me) {
    ///<summary>   
    /// calls the webservice and tells it to turn the image (90° right) <br/>
    /// shows the turned image in the preview field for this function the image <br />
    /// only has to be on the Server 
    ///</summary>
    try {
        me.visual.find("#btnSave").button('disable');
        me.visual.find("#btnDelete").button('disable');
        var newMediaValues = {
            updateType: 7, //rotate 
            mediaPath: me.visual.find("#txtMediaPath").val()
        };
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 42, 42, "", "", 2, 2, JSON.stringify(newMediaValues),
            function (result) {
                if (result !== "") {
                    var myObject = JSON.parse(result);
                    me.visual.find('#previewImage').attr('src', myObject.Base64);
                    me.visual.find('#txtMediaPath').val(myObject.MediaPath);
                    me.data.mediaPath = myObject.MediaPath;
                    me.data.mediaDim = myObject.Dimension;
                    me.validateGallery();

                } else {
                    me.showInfo(me.resources.couldNotTurnImage, "", true);
                }
            });
    } catch (e) {
        me.error = true;
        me.writeError("GalleryUpload.rotateImage", e);
    }
};
galleryUpload.prototype.validateFile = function (file) {
    ///<summary>
    ///Attempts to validate a file according to size and extension
    ///</summary>
    var me = this;
    var ret = false;
    var acceptFileTypes = new RegExp('((jpg)|(jpeg)|(JPG)|(JPEG)|(gif)|(GIF)|(PNG)|(png)|(mp4)|(MP4)|(mp3)|(MP3)|(ogg)|(OGG)|(doc)|(DOC)|(docx)|(DOCX)|(pdf)|(PDF)|(xls)|(XLS)|(xlsx)|(XLSX)|(xlsm)|(Xlxm)|(kdb)|(KDB)|(kdbx)|(KDBX))$');
    try {
        if (file === null && me.data.mediaId !== -1) { ret = true; }
        else if (file.size > 20 * 1024 * 1024) { // 'test Filesize <= 20MB
            me.showInfo(me.resources.fileTooBig, me.resources.maxFileSize, true);
            me.visual.find('#boxtxtUploadField').removeClass('formItemValid').addClass('formItemInvalid');
        } else if (!acceptFileTypes.test(file.name.substring(file.name.lastIndexOf('.')))) {
            me.showInfo(me.resources.invalidFiletype, me.resources.allowedExtensions, true);
            me.visual.find('#boxtxtUploadField').removeClass('formItemValid').addClass('formItemInvalid');
        } else {
            me.visual.find('#boxtxtUploadField').removeClass('formItemInvalid').addClass('formItemValid');
            ret = true;
        }

      
        me.setButtonStates();
    } catch (ex) {
        me.error = true;
        me.writeError("validateFile", ex);
    }
    return ret;
};

galleryUpload.prototype.validate = function (id) {
    ///<summary>
    ///validates the name Field basically just on the length <br/>
    ///</summary>
    var me = this;
    var bValid = false;
    try {
        var nameLength = window.trimAll(me.visual.find('#' + id).val()).length;
        var min = 5;
        var max = 200;
        if (nameLength < min) {
            me.showInfo(me.resources.invalidInput, me.formatString(me.resources.minChars, [min]), true);
            me.invalidInput = true;
        } else if (nameLength > max) {
            me.showInfo(me.resources.invalidInput, me.formatString(me.resources.maxChars, [max]), true);
            me.invalidInput = true;
        } else {
            bValid = true;
        }
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.validateForm", ex);
    }
    return bValid;
};
galleryUpload.prototype.formatString = function (source, params) {
    ///<summary>
    ///uses a given String containing .NET like Placeholders "{#}"  <br/>
    ///and returns it complete with the placeholder text
    ///</summary>
    var me = this;
    try {
        $.each(params,
            function (i, n) {
                source = source.replace(new RegExp("\\{" + i + "\\}", "g"),
                    function () {
                        return n;
                    });
            });
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.formatString", ex);
        source = "";
    }
    return source;
};

galleryUpload.prototype.validateGallery = function () {
    ///<summary>
    ///Enables/Disables the Save Button based on the validations
    ///</summary>
    var me = this;
    try {
        me.setButtonStates();
        me.visual.find('#info').hide();
        if (me.data.mediaId !== -1) { //if the id is not -1 then it means the file is to be changed
            if (me.validate('txtFileName') && me.validateFile(null)) {
                me.visual.find('#btnSave').button({ disabled: false });
            }
        } else if (me.validate('txtFileName')) {
            me.visual.find('#btnSave').button({ disabled: false });
        }
    } catch (ex) {
        me.error = true;
        me.writeError("GalleryUpload.validateGallery", ex);
    }
};

galleryUpload.prototype.setPreview = function (name, ending, isImage, path) {
    /// <summary>
    ///  Helperfunction: shows a preview fo the current File that is uploaded
    ///  if it is not an image a filetype icon is shown instead
    /// </summary>
    var me = this;
    try {
        me.visual.find("#chosenFile").html(name);
        if (!isImage) {
            me.visual.find('#previewIcon').addClass(me.getIconByEnding(ending)).show();
            me.visual.find('#previewImage').hide();
        } else {
            me.visual.find("#previewImage").attr('src', typeof path === "string" ? path : URL.createObjectURL(path));
            me.visual.find("#previewIcon").hide();
            me.visual.find("#previewImage").show();
        }
    } catch (e) { me.error = true; window.writeError('GalleryUpload.setPreview', e); }
};

galleryUpload.prototype.getIconByEnding = function (ending) {
    ///<summary> determines the filetype icon according to the filending <br/>
    /// e.g. .pdf ==> fa fa-file-pdf </summary>
    /// <param name="ending"> a string containg the ending </param>
    /// <returns> a string containing the file icon from font awesome <br />
    /// for unsupported extensions this is fa-file <br />
    /// in case of an error this is icon-warning-sign
    ///</returns>
    var me = this;
    var icon;
    try {
        switch (ending) {
            /*PDF */
            case ".pdf":
            case ".PDF":
                icon = "fa fa-file-pdf";
                break;

            /* DOC */
            case ".doc":
            case ".DOC":
            case ".DOCX":
            case ".docx": //fallthrough up to here
                icon = "fa fa-file-word";
                break;
            /*EXCEL */
            case ".xls":
            case ".XLS":
            case ".XLSX":
            case ".xlsx":
                icon = "fa fa-file-excel";
                break;

            /*AUDIO */
            case ".mp3":
            case ".MP3":
            case ".ogg":
            case ".OGG":
                icon = "fa fa-file-audio";
                break;

            /* KEEPASS */
            case ".kdb":
            case ".KDB":
            case ".KDBX":
            case ".kdbx":
                icon = "fa fa-lock";
                break;

            /*VIDEO */
            case ".mp4":
            case ".MP4":
                icon = "fa fa-file-video";
                break;

            default:
                icon = "fa fa-file";
                break;
        }
    } catch (ex) {
        icon = "fa icon-warning-sign";
        me.error = true;
        me.writeError("GalleryUpload.getIconByEnding", ex);
    }
    return icon;
}; 